import { useParams } from "react-router-dom";
import { useMyClients } from "./use-clients";
import type { ClientPermission } from "../types";

/**
 * Hook to check if the current user has specific permissions in the current client
 */
export function usePermissions(): ClientPermission[] {
  const { company: clientId } = useParams<{ company: string }>();
  const { data: clients = [] } = useMyClients();

  const currentClient = clients.find((c) => c.client.id === clientId);
  return currentClient?.permissions || [];
}

/**
 * Check if user has a specific permission
 */
export function useHasPermission(permission: ClientPermission): boolean {
  const permissions = usePermissions();
  return permissions.includes(permission);
}

/**
 * Check if user has any of the specified permissions
 */
export function useHasAnyPermission(
  permissionsList: ClientPermission[],
): boolean {
  const permissions = usePermissions();
  return permissionsList.some((p) => permissions.includes(p));
}

/**
 * Check if user has all of the specified permissions
 */
export function useHasAllPermissions(
  permissionsList: ClientPermission[],
): boolean {
  const permissions = usePermissions();
  return permissionsList.every((p) => permissions.includes(p));
}
